import React, { useContext } from 'react'
import { store } from '../../stores/pages'
import { Button } from 'reactstrap'

export default function PageStatus() {
  const { refreshing, saving, actions, dispatch, admin } = useContext(store)

  const updateTheme = () => {
    dispatch({ type: actions.UPDATE_HTML })
  }

  const updateThemeButton = !refreshing && (
    <Button color="primary" className="producer-update-preview-button" onClick={updateTheme} disabled={refreshing || saving}>
      Update Theme
    </Button>
  )

  const refreshingStatus = refreshing && (
    <>
      <div className="spinner spinner-sm me-2"></div>
      Updating
    </>
  )

  return admin?.devMode && (
    <div className="producer-status">
      {refreshingStatus || updateThemeButton}
    </div>
  )
}
